import React, { useState } from 'react';
import { ConfirmationModal, IconButton, useGlobalContext } from 'seagull';
import { TrashLine } from 'seagull/icons';
import { useStoreActions } from "../../../../../contexts";
import { Intent } from "../../../../../infra/access-control";
export function CreditDeleteButton(props) {
  const {
    chargeId,
    agreementId,
    disabled,
    tooltipTitle,
    'data-testid': testid,
    onRefresh
  } = props;
  const [loading, setLoading] = useState(false);
  const globalContext = useGlobalContext();
  const {
    api,
    logBI
  } = useStoreActions();

  async function onDelete() {
    const confirmed = await globalContext.showModal({
      closeOnClickOutside: true,
      shouldBlurBackground: true,
      closeOnEscapeKey: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          skin: "danger",
          title: "Are you sure?",
          content: "You are about to remove credit from your client's account. Your client will be notified on this change.",
          primaryButtonLabel: "Remove credit",
          secondaryButtonLabel: "Cancel",
          onPrimaryButtonClick: () => dismissModal(true),
          onSecondaryButtonClick: () => dismissModal(false)
        });
      }
    });
    if (!confirmed) return;
    setLoading(true);
    logBI(10567);

    try {
      await api.charge.delete(agreementId, chargeId);
      await onRefresh({
        silent: true
      });
      globalContext.showSuccessToast('Credit removed', "".concat(testid, "-success"));
    } catch (e) {
      setLoading(false);
      globalContext.showErrorToast('Failed to remove credit, please try again or contact support@sayanchor.com for assistance', "".concat(testid, "-failure"));
    }
  }

  return /*#__PURE__*/React.createElement(IconButton, {
    onClick: onDelete,
    disabled: disabled || loading,
    skin: "primary",
    "data-testid": testid,
    intent: Intent.RemoveCredit,
    tooltip: {
      placement: 'top',
      title: /*#__PURE__*/React.createElement("div", {
        "data-testid": testid && "".concat(testid, "-tooltip")
      }, tooltipTitle || 'Remove credit')
    }
  }, /*#__PURE__*/React.createElement(TrashLine, null));
}